import React, { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { fetchProcesoCarritoAccP, fetchRecuperarCarritoAccP } from '../../redux/actions/aRamoAccidentesPersonales';
import { Alert, Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Page from '../Page';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { Checkbox } from "react-inputs-validation";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { urlLimitesAp, urlRecuperarCotizadorParametrico, urlTextosAp } from '../../constants/urls';

const CotizacionAccPersonalVigencia = (props) => {
    const dispatch = useDispatch();

    const datosRecuperarCarritoAccP = useSelector(state => state.datosRecuperarCarritoAccP);
    const datosCarritoAccP = useSelector(state => state.datosCarritoAccP);
    const datosProcesoCarritoAccP = useSelector(state => state.datosProcesoCarritoAccP);


    useEffect(async () => {

        obtenerInformacion()

        if (props.datosRecuperados) {



            var diferenciaDias = moment(new Date(fechaInicio)).diff(new Date(), 'days');
            console.log('diferenciaDias', diferenciaDias)
            if (diferenciaDias >= (parseInt(limiteFechaInicioPasado) * -1) && diferenciaDias < parseInt(limiteFechaInicioFuturo)) {
                setFechaInicioError(false)
                if (diferenciaDias < 0) {
                    setMostrarRiesgo(true)
                    if (valuePregunta == null) {
                        setValuePregunta('si')
                        //setPreguntaNoSeleccionada(true)
                    }

                    if (valuePregunta == 'si') {


                    }
                } else {
                    setMostrarRiesgo(false)

                }
            } else {
                setFechaInicioError(true)

            }

        }



    }, []);

    const obtenerInformacion = async () => {


        var url = `${urlLimitesAp}Guardias`;
        try {
            const response = await fetch(url, { method: 'GET' })
            const json = await response.json()

            if (json.transaccion) {

                setMinimoVigencia(json.limites.min)
                setMaximoVigencia(json.limites.max)

                setLimiteFechaInicioPasado(json.limitesInicio.min)
                setLimiteFechaInicioFuturo(json.limitesInicio.max)
            }
        } catch (error) {
        }


        var url = `${urlTextosAp}restriccion-siniestralidad`;
        try {
            const response = await fetch(url, { method: 'GET' })
            const json = await response.json()

            if (json.transaccion) {
                console.log('pregunta', json.texto)

                setMensajeErrorPregunta(json.texto)

                
            }
        } catch (error) {
        }

        var url = `${urlTextosAp}declaracion-siniestralidad`;
        try {
            const response = await fetch(url, { method: 'GET' })
            const json = await response.json()

            if (json.transaccion) {
                console.log('pregunta', json.texto)

                setPregunta(json.texto)

                
            }
        } catch (error) {
        }
    }


    const [fechaInicio, setFechaInicio] = useState(props.fechaInicio)
    const [fechaInicioError, setFechaInicioError] = useState(false)
    const [limiteFechaInicioPasado, setLimiteFechaInicioPasado] = useState(5)
    const [limiteFechaInicioFuturo, setLimiteFechaInicioFuturo] = useState(30)


    const [fechaFin, setFechaFin] = useState(props.fechaFin)
    const [fechaFinError, setFechaFinError] = useState(false)
    const [mensajeError, setMensajeError] = useState('')

    const [minimoVigencia, setMinimoVigencia] = useState(365)
    const [maximoVigencia, setMaximoVigencia] = useState(792)
    const [mensajeErrorNoSeleccionado, setMensajeErrorNoSeleccionado] = useState('Por favor seleccionar una respuesta')
    const [preguntaNoSeleccionada, setPreguntaNoSeleccionada] = useState(false)
    const [valuePregunta, setValuePregunta] = useState(null)
    const [mensajeErrorPregunta, setMensajeErrorPregunta] = useState('No se puede cotizar comuniquese con AIG.')
    const [mostrarRiesgo, setMostrarRiesgo] = useState(false)
    const [pregunta, setPregunta] = useState('1. ¿Se confirma que los asegurados declarados en la facturación inicial, no presentan siniestros a la fecha?')


    const validarFormulario = async () => {

        let continuar = true

        var diferenciaDias = moment(new Date(fechaInicio)).diff(new Date(), 'days');
        console.log('diferenciaDias', diferenciaDias)
        if (diferenciaDias >= (parseInt(limiteFechaInicioPasado) * -1) && diferenciaDias < parseInt(limiteFechaInicioFuturo)) {
            setFechaInicioError(false)
            if (diferenciaDias < 0) {
                setMostrarRiesgo(true)
                if (valuePregunta == null) {
                    continuar = false
                    setPreguntaNoSeleccionada(true)
                }

                if (valuePregunta == 'no') {
                    continuar = false

                }
            } else {
                setMostrarRiesgo(false)

            }
        } else {
            setFechaInicioError(true)
            continuar = false
        }



        diferenciaDias = moment(new Date(fechaFin)).diff(fechaInicio, 'days');


        if (diferenciaDias < 0) {
            setFechaFinError(true)
            setMensajeError(`Debe seleccionar una fecha mayor a  ${moment(fechaInicio).format('DD/MM/yyyy')}`)
            continuar = false
        } else if (diferenciaDias < minimoVigencia || diferenciaDias > maximoVigencia) {
            setFechaFinError(true)
            setMensajeError(`La vigencia de la póliza debe ser mínimo de ${minimoVigencia} días hasta ${maximoVigencia} días.`)
            continuar = false
        } else {
            setFechaFinError(false)
            setMensajeError(``)
        }



        if (continuar) {

            dispatch(fetchProcesoCarritoAccP({
                empresa: "AIGMETROPOLITANA",
                pasoCarrito: "vigencia",
                plataforma: 'WEB',
                idCarrito: props.idCarrito,
                fechaEmisionRetroactivaFutura: fechaInicio,
                fechaEmisionRetroactivaFuturaFin: fechaFin
            }))

            if (
                !datosProcesoCarritoAccP.procesoCarritoAccPIsLoading &&
                !datosProcesoCarritoAccP.procesoCarritoAccPhasError
            ) {

                props.onSiguiente()

            }

        }


    }





    return (

        <LoadingScreen
            loading={
                datosProcesoCarritoAccP.procesoCarritoAccPIsLoading
            }
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando datos..."
        >
            <Page
                title="Cotización Accidentes Personales"
                breadcrumbs={[{ name: "Cotización Accidentes", active: true }]}
            >
                <div className="container-step ">
                    <div className="wrapper-step">
                        <div className="arrow-steps clearfix-step">
                            <div className="step current"> {` 1. Cotización `} </div>
                            <div className="step"> {` 2. Resumen `} </div>
                            <div className="step"> {` 3. Confirmación `} </div>
                            <div class="step"> {` 4. Forma de Pago `} </div>
                            <div class="step"> {` 5. Formulario de Vinculación `} </div>
                            <div class="step"> {` 6. Emisión `} </div>
                        </div>
                    </div>
                </div>

                <Col lg={8} md={12} sm={12} xs={12} className="div-align-center">
                    <Row className="menu-superior-pantallas-grandes">
                        <Col lg={11} md={12} sm={12} xs={12} className="div-align-center">
                            <Card className="">
                                <CardHeader>
                                    Vigencia de Póliza
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col lg={4} md={6} sm={6} xs={12}>

                                            {`Fecha de Inicio de vigencia`}

                                        </Col>
                                        <Col lg={4} md={6} sm={6} xs={12}>

                                            <DatePicker

                                                dateFormat="dd/MM/yyyy"
                                                isClearable={false}
                                                selected={new Date(fechaInicio)}
                                                onChange={(valor) => {
                                                    var diferenciaDias = moment(new Date(valor)).diff(new Date(), 'days');
                                                    console.log('diferenciaDias', diferenciaDias)
                                                    if (diferenciaDias >= (parseInt(limiteFechaInicioPasado) * -1) && diferenciaDias < parseInt(limiteFechaInicioFuturo)) {
                                                        setFechaInicioError(false)
                                                        if (diferenciaDias < 0) {
                                                            setMostrarRiesgo(true)
                                                        } else {
                                                            setMostrarRiesgo(false)

                                                        }
                                                    } else {
                                                        setFechaInicioError(true)
                                                    }


                                                    setFechaInicio(valor);
                                                }}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                className="form-control"

                                            />

                                            {fechaInicioError ?
                                                <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">
                                                    {`Debe seleccionar una fecha entre ${moment(new Date()).add(-parseInt(limiteFechaInicioPasado), 'days').format('DD/MM/yyyy')} - ${moment(new Date()).add(parseInt(limiteFechaInicioFuturo), 'days').format('DD/MM/yyyy')}`}
                                                </div> : null
                                            }

                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg={4} md={6} sm={6} xs={12}>

                                            {`Fecha de Fin de vigencia`}

                                        </Col>
                                        <Col lg={4} md={6} sm={6} xs={12}>

                                            <DatePicker

                                                dateFormat="dd/MM/yyyy"
                                                isClearable={false}
                                                selected={new Date(fechaFin)}

                                                onChange={(valor) => {

                                                    setFechaFin(valor);

                                                    var diferenciaDias = moment(new Date(valor)).diff(fechaInicio, 'days');
                                                    console.log('diferenciaDias', diferenciaDias)

                                                    if (diferenciaDias < 0) {
                                                        setFechaFinError(true)
                                                        setMensajeError(`Debe seleccionar una fecha mayor a  ${moment(fechaInicio).format('DD/MM/yyyy')}`)
                                                    } else if (diferenciaDias < minimoVigencia || diferenciaDias > maximoVigencia) {
                                                        setFechaFinError(true)
                                                        setMensajeError(`La vigencia de la póliza debe ser mínimo de ${minimoVigencia} días hasta ${maximoVigencia} días.`)
                                                    } else {
                                                        setFechaFinError(false)
                                                        setMensajeError(``)
                                                    }





                                                }}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                className="form-control"

                                            />

                                            {fechaFinError &&
                                                <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">
                                                    {mensajeError}
                                                </div>
                                            }

                                        </Col>

                                    </Row>

                                    {/*  <Alert color='warning'>
                                    Su solicitud de vigencia retroactiva o futura requiere el análisis y la autorización del área de suscripción de AIG, puede revisar el estado en el “Administrador del portal”
                                </Alert> */}

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {mostrarRiesgo &&
                        <Row className="menu-superior-pantallas-grandes">
                            <Col lg={11} md={12} sm={12} xs={12} className="div-align-center">
                                <Card className="">
                                    <CardHeader>
                                        Validación de siniestralidad
                                    </CardHeader>
                                    <CardBody>
                                        <Row >
                                            <Col lg={4} md={4} sm={12} xs={12} >
                                                <p style={{ fontWeight: "200", textAling: "justify" }}>{pregunta}</p>
                                            </Col>
                                            <Col lg={4} md={4} sm={12} xs={12}  >
                                                <Row>
                                                    <Col md={6} sm={6} xs={6} >
                                                        <Checkbox
                                                            id={`preguntaSI`} // Optional.[String].Default: "".  Input ID.
                                                            name={`preguntaSI`}
                                                            //value={factotal} // Required.[String].Default: "".
                                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                            checked={valuePregunta == 'si'} // Required.[Bool].Default: false.
                                                            onChange={(res, e) => {


                                                                setValuePregunta('si')
                                                                setPreguntaNoSeleccionada(false)


                                                            }}
                                                            labelHtml={
                                                                <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                                                                    SI
                                                                </div>
                                                            } // Required.[Html].Default: none.
                                                            validationOption={{
                                                                name: 'preguntaSI', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col md={6} sm={6} xs={6} >
                                                        <Checkbox
                                                            id={`preguntaNO`} // Optional.[String].Default: "".  Input ID.
                                                            name={`preguntaNO`}
                                                            //value={factotal} // Required.[String].Default: "".
                                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                            checked={valuePregunta == 'no'} // Required.[Bool].Default: false.
                                                            onChange={(res, e) => {
                                                                setValuePregunta('no')
                                                                setPreguntaNoSeleccionada(false)
                                                            }}
                                                            labelHtml={
                                                                <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                                                                    NO
                                                                </div>
                                                            } // Required.[Html].Default: none.
                                                            validationOption={{
                                                                name: 'preguntaNO', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                                {preguntaNoSeleccionada &&
                                                    <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">
                                                        {mensajeErrorNoSeleccionado}
                                                    </div>
                                                }

                                            </Col>
                                        </Row>
                                        {valuePregunta == 'no' &&
                                            <Row  >
                                                <Col md={10} sm={12} className="div-align-center">
                                                    <Alert color="danger">
                                                        <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                                                        <p style={{ textAlign: "center" }}>{mensajeErrorPregunta}</p>

                                                    </Alert>
                                                </Col>
                                            </Row>
                                        }



                                        {/*  <Alert color='warning'>
                                    Su solicitud de vigencia retroactiva o futura requiere el análisis y la autorización del área de suscripción de AIG, puede revisar el estado en el “Administrador del portal”
                                </Alert> */}

                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col lg={1}></Col>
                        <Col
                            lg={5}
                            md={6}
                            sm={12}
                            xs={12}
                            className="div-align-center"
                        >
                            <Button
                                className="btn btn-detail-gray"
                                onClick={() => { props.onRegresar() }}
                            >
                                <i
                                    className="fa fa-chevron-circle-left"
                                    aria-hidden="true"
                                />{" "}
                                {"REGRESAR"}
                            </Button>
                        </Col>

                        <Col
                            lg={5}
                            md={6}
                            sm={12}
                            xs={12}
                            className="div-align-center"
                        >

                            <Button
                                className="btn btn-primary"
                                onClick={() => { validarFormulario() }}
                                style={{
                                    display: "block",
                                    margin: "auto",
                                    float: "right",
                                }}
                            >
                                <i
                                    className="fa fa-chevron-circle-right"
                                    aria-hidden="true"
                                />{" "}
                                {"CONTINUAR"}
                            </Button>

                        </Col>
                        <Col lg={1}></Col>
                    </Row>


                </Col>

            </Page>
        </LoadingScreen>
    )

}


export default CotizacionAccPersonalVigencia
